module.exports = __webpack_public_path__ + "static/media/9_evenement.f3835f05.jpg";